export default "__VITE_ASSET__qwDnHH6D__"